import { render, staticRenderFns } from "./StatTaskFiles.vue?vue&type=template&id=5195e288&"
import script from "./StatTaskFiles.vue?vue&type=script&lang=ts&"
export * from "./StatTaskFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports